import Permits from './Permits';

export default Permits;
